import React from 'react';
import PhoneFormat from 'app/main/components/PhoneFormat';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import FuseChipSelect from '@fuse/core/FuseChipSelect';
import UsDateField from 'app/main/components/UsDateField';

const US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming'
];

const stateOptions = US_STATES.map(state => ({
  value: state,
  label: state
}));

function BasicInfoTab({ form, setForm, handleChange }) {
  return (
    <>
      <Alert severity="info" className="mb-16">
        This is strictly legal information, kept private for HR and Admin use only.
      </Alert>

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="firstName"
        name="firstName"
        label="Legal Name"
        value={form.firstName || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="legalMiddleName"
        name="legalMiddleName"
        label="Legal Middle Name (optional)"
        value={form.legalMiddleName || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="lastName"
        name="lastName"
        label="Legal Last Name"
        value={form.lastName || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <UsDateField
        fullWidth
        className="mt-8 mb-16"
        id="birthday"
        name="birthday"
        label="Birthdate"
        value={form.birthday || ''}
        onChange={handleChange}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="phoneNumber"
        name="phoneNumber"
        label="Personal Phone Number"
        value={form.phoneNumber || ''}
        variant="outlined"
        onChange={handleChange}
        InputProps={{ inputComponent: PhoneFormat }}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="email"
        name="email"
        label="Personal Email Address"
        value={form.email || ''}
        variant="outlined"
        onChange={handleChange}
        // InputProps={{ readOnly: true }}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="streetAddress"
        name="streetAddress"
        label="Address Line 1"
        value={form.streetAddress || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="streetAddress2"
        name="streetAddress2"
        label="Address Line 2"
        value={form.streetAddress2 || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <div className="flex gap-16 mt-8 mb-16">
        <TextField
          fullWidth
          id="city"
          name="city"
          label="City"
          variant="outlined"
          value={form.city || ''}
          onChange={handleChange}
        />

        <FuseChipSelect
          id="state"
          name="state"
          isMulti={false}
          isSearchable={false}
          className="w-full"
          value={form.state ? { value: form.state, label: form.state } : null}
          options={stateOptions}
          onChange={selected => setForm({ ...form, state: selected?.value || '' })}
          textFieldProps={{
            label: 'State',
            InputLabelProps: { shrink: true },
            variant: 'outlined'
          }}
          menuPosition="absolute"
          menuShouldScrollIntoView={false}
          menuPlacement="auto"
          valueContainerStyle={{ padding: 0, maxHeight: 40 }}
          placeholderStyle={{ fontSize: '14px' }}
          singleValueStyle={{
            width: '100%',
            boxSizing: 'border-box',
            fontSize: '14px',
            lineHeight: '19px',
            padding: '18.5px 14px'
          }}
          optionStyle={{
            boxSizing: 'border-box',
            fontSize: '14px',
            lineHeight: '19px'
          }}
          styles={{
            control: base => ({
              ...base,
              minHeight: 54,
              height: 54
            }),
            valueContainer: base => ({
              ...base,
              height: 54,
              paddingTop: 0,
              paddingBottom: 0
            }),
            indicatorsContainer: base => ({
              ...base,
              height: 54
            }),

            option: base => ({
              ...base,
              height: 32,
              minHeight: 32,
              maxHeight: 32,
              padding: '6px 12px',
              // fontSize: isMobile ? '12px' : '14px',
              lineHeight: '20px',
              boxSizing: 'border-box'
            }),

            menuList: base => ({
              ...base,
              // maxHeight: isMobile ? 180 : 140,
              maxHeight: 180,
              paddingTop: 0,
              paddingBottom: 0,
              marginTop: -10,
              overflowY: 'auto'
            }),

            singleValue: base => ({
              ...base,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }),

            menuPortal: base => ({
              ...base,
              zIndex: 9999
            })
          }}
        />
      </div>

      {/* <TextField
        fullWidth
        className="mt-8 mb-16"
        id="city"
        name="city"
        label="City"
        value={form.city || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="state"
        name="state"
        label="State"
        value={form.state || ''}
        variant="outlined"
        onChange={handleChange}
      /> */}

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="zipcode"
        name="zipcode"
        label="Zipcode"
        value={form.zipcode || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="emergencyContactName"
        name="emergencyContactName"
        label="Emergency Contact Name"
        value={form.emergencyContactName || ''}
        variant="outlined"
        onChange={handleChange}
      />

      <TextField
        fullWidth
        className="mt-8 mb-16"
        id="emergencyContactPhone"
        name="emergencyContactPhone"
        label="Emergency Contact Phone"
        value={form.emergencyContactPhone || ''}
        variant="outlined"
        onChange={handleChange}
        inputProps={{ autoComplete: 'off' }}
        InputProps={{ inputComponent: PhoneFormat }}
      />
    </>
  );
}

export default BasicInfoTab;
